<template>
    <div class="v-flex align-items-center notewrap" 
    :class="[{ unread: note.status=='1' }, '' ]"
    @click="workNote">
        <div class="usr-dp">
            <UserDp :user="{ name: note.name, dp: note.dp }" />
        </div>
        <div class="flex-grow-1">
            <h6 class="msg-name">{{note.name}}
                <span class="msg-time float-end">
                    {{ note.time }}
                </span></h6>
            <p class="msg-info">{{note.note}}</p>
        </div>
    </div>
</template>
<script>
import UserDp from './UserDp.vue';
export default {
    name: "UserDP",
    components:{UserDp},
    props: {
        note: {
            type: Object,
            required: true
        },
    },
    setup(props,ctx){
        function workNote(){
            ctx.emit("noteClick",props.note)
        }
        return{workNote}
    }
}
</script>
<style scoped>
.usr-dp{flex: 0 0 auto;}
.unread{background: var(--light-row-color);}
.notewrap{margin-bottom: 5px; margin-left: -1.3rem; margin-right: -1.3rem; padding: 0.5rem 1.3rem;}
.notewrap:last-child{margin-bottom:0}
</style>
